import { create } from 'zustand';

type SideNavigationMode = 'open' | 'collapsed' | 'hidden';

type SideNavigationState = {
  /** サイドナビゲーションの表示モード */
  mode: SideNavigationMode;
  /** hidden前のモードを保持（再表示時に復元するため） */
  previousMode: 'open' | 'collapsed';
  /** 後方互換: open状態かどうか */
  isOpen: boolean;
  /** サイドメニュー内のボタンで開閉（open ↔ collapsed） */
  toggleCollapse: () => void;
  /** GlobalNavigationのボタンで表示/非表示（hidden ↔ previousMode） */
  toggleVisibility: () => void;
};

/**
 * 左サイドナビゲーションの表示モードを管理するZustandストア
 *
 * 3つの状態:
 * - open: 展開表示（240px） - ロゴ + ラベル付きメニュー
 * - collapsed: アイコンのみ表示（52px）
 * - hidden: 完全非表示（0px）
 */
export const useSideNavigationStore = create<SideNavigationState>((set) => ({
  mode: 'collapsed',
  previousMode: 'collapsed',
  isOpen: false,
  toggleCollapse: () =>
    set((state) => {
      const newMode = state.mode === 'open' ? 'collapsed' : 'open';
      return { mode: newMode, isOpen: newMode === 'open' };
    }),
  toggleVisibility: () =>
    set((state) => {
      if (state.mode === 'hidden') {
        // 非表示前のモードに復元
        return {
          mode: state.previousMode,
          isOpen: state.previousMode === 'open',
        };
      }
      // 現在のモードを保持してから非表示にする
      return {
        mode: 'hidden' as const,
        previousMode: state.mode as 'open' | 'collapsed',
        isOpen: false,
      };
    }),
}));
